import {Stack, Heading} from '@primer/react-brand'
import {ContentfulCards} from '@github-ui/swp-core/components/contentful/ContentfulCards'

import styles from './RelatedResources.module.css'
import type {PrimerComponentCard} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCard'

type RelatedResourcesProps = {
  relatedResources: PrimerComponentCard[]
  headingText?: string
}

const DEFAULT_HEADING_TEXT = 'Explore other resources'

export default function RelatedResources({relatedResources, headingText}: RelatedResourcesProps) {
  return (
    <Stack direction="vertical" padding="none" gap={{narrow: 40, regular: 64}}>
      <Heading as="h2" size="5">
        {headingText || DEFAULT_HEADING_TEXT}
      </Heading>

      <ContentfulCards cards={relatedResources} className={styles.relatedCards} imageAspectRatio="16:9" fullWidth />
    </Stack>
  )
}
